
export function strToInt(s) {
    const amt = Number(s);
    if (isNaN(amt)) {
        return null;
    } 
    return amt;
}

export function formatDbAddress(addressObj) {
    console.log('here is addressObj in dtypeUtils: ', JSON.stringify(addressObj));
    const street = addressObj?.street ?? null;
    const city = addressObj?.city ?? null;
    const country = addressObj?.country ?? null;

    console.log('street in formatDbAddress() of utils.js: ', street);
    console.log('city in formatDbAddress() of utils.js: ', city);
    console.log('country in formatDbAddress() of utils.js: ', country);
    const valids = [
        street,
        city,
        country,
    ].filter(Boolean);

    if (!valids?.length) return null;

    return valids.join(', ');
}